import { Directive } from '@angular/core';
import { getInsuranceTypeLabel } from 'src/app/_enums/insurance-type.enum';
import {
  BusinessBuildingInsuranceMetadata,
  BusinessConstructionInsuranceMetadata,
  BusinessConstructionWarrantyInsuranceMetadata,
  BusinessCyberInsuranceMetadata,
  BusinessRcProfessionalInsuranceMetadata,
  BusinessRentalInsuranceMetadata,
  BusinessTransportInsuranceMetadata,
} from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class BusinessBasicMetadataComponentAbstract extends BaseMetadataComponent<
  | BusinessRentalInsuranceMetadata
  | BusinessCyberInsuranceMetadata
  | BusinessConstructionWarrantyInsuranceMetadata
  | BusinessConstructionInsuranceMetadata
  | BusinessTransportInsuranceMetadata
  | BusinessRcProfessionalInsuranceMetadata
  | BusinessBuildingInsuranceMetadata
> {
  getInsuranceTypeLabel = getInsuranceTypeLabel;

  submitted = false;
}
